export let Success = (props) => {
  return (
    <div
      style={{ backgroundColor: '#d4edda', padding: '1rem', color: '#155724' }}>
      {props.message}
    </div>
  );
};
